import { blinkConstants } from '@thoughtspot/blink-constants';
import { isCustomOrTsHostedChart } from '@thoughtspot/chart-lib/lib/core/chart-type-specification-service';
import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import { create } from '@thoughtspot/logger';
import { isUnsavedChangesModalEnabledForAdhocAnswer } from '@thoughtspot/session-service';
import { getCustomChartContext } from '@thoughtspot/ts-chart-app';
import _ from 'lodash';
import { ParsedQs } from 'qs';
import React from 'react';
import { getAnswerPageConfig } from '/@contexts/answer-context';
import { useBachAcHistoryContext } from '/@contexts/bach-ac-history-context';
import {
    useBachLazyQuery,
    useBachMutation,
    useBachQuery,
} from '/@services/bach/bach';
import { useGatedBachMutation } from '/@services/bach/bach-gated';
import { useCancelableMutation } from '/@services/cancelable/cancelable-hooks';
import {
    A3AnalysisSubmissionDocument,
    A3AnalysisSubmissionMutation,
    A3AnalysisSubmissionMutationVariables,
    A3AnalysisSyncDocument,
    A3AnalysisSyncMutation,
    A3AnalysisSyncMutationVariables,
    AddAndRemoveColumnDocument,
    AddAndRemoveColumnMutation,
    AddAndRemoveColumnMutationVariables,
    AddColumnsDocument,
    AddColumnsMutation,
    AddColumnsMutationVariables,
    Answer,
    AnswerColumnInfo,
    AnswerContextType,
    BachSessionId,
    BachSessionIdInput,
    ChartType,
    ChartVisualOverridesFragmentDoc,
    ChartViz,
    ChartVizProps,
    ChipFragmentDoc,
    ChipInput,
    ClearAnswerAndSetSourcesDocument,
    ClearAnswerAndSetSourcesMutation,
    ClearAnswerAndSetSourcesMutationVariables,
    ClearAnswerDocument,
    ClearAnswerMutation,
    ClearAnswerMutationVariables,
    CopyAnswerDocument,
    CopyAnswerMutation,
    CopyAnswerMutationVariables,
    CreateViewDocument,
    CreateViewMutation,
    CreateViewMutationVariables,
    CustomRAnalysis,
    DataPaginationParamsInput,
    DataQueryInput,
    DeleteAnswerDocument,
    DeleteAnswerMutation,
    DeleteAnswerMutationVariables,
    DisplayMode,
    EmptyAnswer,
    GetA3AnalysisColumnsDocument,
    GetA3AnalysisColumnsMutation,
    GetA3AnalysisColumnsMutationVariables,
    GetAnswerChartColumnsAndDataDocument,
    GetAnswerDataByQueryDocument,
    GetAnswerDataByQueryQuery,
    GetAnswerDataByQueryQueryVariables,
    GetAnswerDocument,
    GetAnswerFromTokensDocument,
    GetAnswerFromTokensMutation,
    GetAnswerFromTokensMutationVariables,
    GetAnswerMetadataDocument,
    GetAnswerMetadataQuery,
    GetAnswerMetadataQueryVariables,
    GetAnswerOrderedChipsDocument,
    GetAnswerOrderedChipsQuery,
    GetAnswerOrderedChipsQueryVariables,
    GetAnswerQuery,
    GetAnswerQueryVariables,
    GetAnswerSessionDocument,
    GetAnswerSessionQuery,
    GetAnswerSessionQueryVariables,
    GetAnswerTableColumnsAndDataDocument,
    GetAnswerTitleDocument,
    GetAnswerTitleQuery,
    GetAnswerTitleQueryVariables,
    GetBrokenAnswerDetailsDocument,
    GetBrokenAnswerDetailsQuery,
    GetBrokenAnswerDetailsQueryVariables,
    GetColumnValuesDocument,
    GetColumnValuesMutation,
    GetColumnValuesMutationVariables,
    GetInsightDataDocument,
    GetInsightDataQuery,
    GetInsightDataQueryVariables,
    GetIsAnswerMutationInProgressDocument,
    GetIsAnswerMutationInProgressQuery,
    GetIsAnswerMutationInProgressQueryVariables,
    GetNaturalLanguageQueryDocument,
    GetNaturalLanguageQueryMutation,
    GetNaturalLanguageQueryMutationVariables,
    GetQueryDocument,
    GetQueryMutation,
    GetQueryMutationVariables,
    GetQvSpecDocument,
    GetQvSpecMutation,
    GetQvSpecMutationVariables,
    GetSelectedColumnsDocument,
    GetSelectedColumnsQuery,
    GetSelectedColumnsQueryVariables,
    GetSelectedOutputColumnsDocument,
    GetSelectedOutputColumnsQuery,
    GetSelectedOutputColumnsQueryVariables,
    GetSelectedSourcesDocument,
    GetSelectedSourcesQuery,
    GetSelectedSourcesQueryVariables,
    GetUnAggregatedAnswerSessionDocument,
    GetUnAggregatedAnswerSessionMutation,
    GetUnAggregatedAnswerSessionMutationVariables,
    GetUnsavedAnswerTmlDocument,
    GetUnsavedAnswerTmlMutation,
    GetUnsavedAnswerTmlMutationVariables,
    GetVisualizedColumnsDocument,
    GetVisualizedColumnsQuery,
    GetVisualizedColumnsQueryVariables,
    HasVisualizationsDocument,
    HasVisualizationsQuery,
    HasVisualizationsQueryVariables,
    HeadlineViz,
    HeadlineVizProps,
    HeadlineVizPropsFragmentDoc,
    LoadingState,
    ParameterFragmentDoc,
    PhraseFragmentDoc,
    PinboardAnswerFragmentDoc,
    PinboardAnswerWithDataFragmentDoc,
    QuerableDataSourceType,
    RAnalysisViz,
    RemoveColumnDocument,
    RemoveColumnMutation,
    RemoveColumnMutationVariables,
    RemoveColumnsDocument,
    RemoveColumnsMutation,
    RemoveColumnsMutationVariables,
    RenameColumnDocument,
    RenameColumnMutation,
    RenameColumnMutationVariables,
    ReportIssueDocument,
    ReportIssueMutation,
    ReportIssueMutationVariables,
    RuntimeFilterInput,
    RuntimeParameterInput,
    RuntimeSortInput,
    SaveAnswerDocument,
    SaveAnswerMutation,
    SaveAnswerMutationVariables,
    SaveWhatIfScenarioDocument,
    SaveWhatIfScenarioMutation,
    SaveWhatIfScenarioMutationVariables,
    ScenarioInput,
    SelectedColumn,
    SetCcaColumnConfigDocument,
    SetCcaColumnConfigMutation,
    SetCcaColumnConfigMutationVariables,
    SetSourcesDocument,
    SetSourcesMutation,
    SetSourcesMutationVariables,
    SetTmlStringDocument,
    SetTmlStringMutation,
    SetTmlStringMutationVariables,
    SubmitRAnalysisDocument,
    SubmitRAnalysisMutation,
    SubmitRAnalysisMutationVariables,
    TableViz,
    TableVizProps,
    TableVizPropsFragmentDoc,
    UpdateAnswerChipsOrderDocument,
    UpdateAnswerChipsOrderMutation,
    UpdateAnswerChipsOrderMutationVariables,
    UpdateAnswerTitleDocument,
    UpdateAnswerTitleMutation,
    UpdateAnswerTitleMutationVariables,
    UpdateChartConfigLockOnSaveDocument,
    UpdateClientStateDocument,
    UpdateColumnDocument,
    UpdateColumnMutation,
    UpdateColumnMutationVariables,
    UpdateDisplayModeDocument,
    UpdateDisplayModeMutation,
    UpdateDisplayModeMutationVariables,
    UpdateLastSelectedDataSourcesDocument,
    UpdateLastSelectedDataSourcesMutation,
    UpdateLastSelectedDataSourcesMutationVariables,
    UpdateSortDocument,
    UpdateSortMutation,
    UpdateSortMutationVariables,
    UpdateViewDocument,
    UpdateViewMutation,
    UpdateViewMutationVariables,
    useCreateAnswerSessionMutation as useCreateAnswer,
    useLoadAnswerSessionMutation as useLoadAnswer,
    useLoadCopiedAnswerFromIdMutation,
    UserPointSelectionInput,
    Visualization,
    VisualOverridesPayloadInput,
} from '/@services/generated/graphql-types';
import { CombinedQueryBuilder, combineQuery } from '/@utils/combine-graphql';
import { isExternalDataSourceType } from '/@utils/embrace-constants';
import { readFromLBChartVizCache } from '/@utils/lb-chartViz-caching-service';
import { useRuntimeParams } from '/@utils/runtime-filters.util';
import { getCommonAnswerPageProperties } from '/@utils/viz/metrics-event.util';
import {
    ApolloCache,
    ApolloClient,
    ApolloError,
    DocumentNode,
    gql,
    MutationResult,
    Reference,
    useApolloClient,
    useMutation,
} from '../../utils/error-handling/apollo-hooks-wrappers/custom-apollo-hooks';
import { BlinkErrorCode } from '../../utils/error-handling/blink-error-boundary';
import {
    BachMutationFunctionOptions,
    bachSessionWithAcSessionKeyQuery,
} from '../bach/bach.util';
import { getSession } from '../stateful/stateful-service-hooks';
import {
    getParsedQueryResponseForAnswerDataByQueryCall,
    shouldCombineMultipleQueriesForCustomChart,
} from '../visualization/data/data-service';
import { useWaitUntilNoMutationIsInFlightHook } from '../wait-until-no-mutation-is-in-flight/waitUntilNoMutationIsInFlight';
import {
    AnswerColumnOptimisicResKey,
    AnswerColumnRenameParam,
    AnswerDisplayModeMutation,
    AnswerPageContext,
    evictAnswerDataByQueryCache,
    evictRefAnswerOfAnswerEditSession,
    FinalVisualization,
    getClientStateRequest,
    getColumnsFromViz,
    getOptimisiticResponseForAnswerTitleDescription,
    getOptimisitResponseForDisplayMutation,
    getOptimisticResponseForColumn,
    getSelectedColumnsFromQueryData,
    getUpdatedCustomVisualProp,
    parseColumnValues,
    refetchVizData,
    setNextGenNoShouldReplaceCurrent,
    setVisualizationLoading,
} from './answer.util';
import {
    fetchVizRefsForAnswerSession,
    getAnswerCacheKey,
    getCachedAnswer,
} from './answer-cache-service';
import {
    mapJoinPathAmbiguityErrorCode,
    shouldRemapToJoinPathAmbiguityError,
} from './answer-error.utils';

const logger = create('answer-service');

enum displayTypes {
    CHART_MODE = 'ChartViz',
    TABLE_MODE = 'TableViz',
    HEADLINE_MODE = 'HeadlineViz',
    R_ANALYSIS_MODE = 'RAnalysisViz',
}
interface RuntimeParams {
    runtimeFilter?: RuntimeFilterInput[];
    runtimeParameters?: RuntimeParameterInput[];
    runtimeSort?: RuntimeSortInput[];
}

export const getCachedAnswerVisualization = (
    cache: ApolloCache<object>,
    answerSessionId: string,
) => {
    return getCachedAnswer(
        cache,
        answerSessionId,
        gql`
            {
                answer {
                    visualizations {
                        id
                        ... on HeadlineViz {
                            id
                            vizProp
                        }
                        ... on ChartViz {
                            id
                            vizProp
                            config {
                                isLocked
                                chartType
                            }
                        }
                        ... on TableViz {
                            id
                            vizProp
                        }
                        ... on RAnalysisViz {
                            id
                        }
                    }
                }
            }
        `,
    );
};

export const getCachedAnswerDetailsForVizSnapShot = (
    cache: ApolloCache<object>,
    answerSessionId: string,
) => {
    return getCachedAnswer(
        cache,
        answerSessionId,
        gql`
            {
                answer {
                    id
                    metadata {
                        generationNum
                    }
                }
            }
        `,
    );
};

export const getAnswerIdForAnswerEditSession = (
    cache: ApolloCache<object>,
    answerSessionId: string,
): string => {
    const answerEditSession = getCachedAnswer(
        cache,
        answerSessionId,
        gql`
            {
                answer {
                    id
                }
            }
        `,
    );
    return answerEditSession?.answer.id;
};

export const getAnswerMetadataForAnswerEditSession = (
    cache: ApolloCache<object>,
    answerSessionId: string,
) => {
    const answerEditSession = getCachedAnswer(
        cache,
        answerSessionId,
        gql`
            {
                answer {
                    id
                    displayMode
                }
            }
        `,
    );
    return answerEditSession?.answer;
};

export const getCachedAnswerForHasUnsavedChanges = (
    cache: ApolloCache<object>,
    answerSessionId: string,
) => {
    const cachedAnswerSession = getCachedAnswer(
        cache,
        answerSessionId,
        gql`
            {
                id {
                    genNo
                }
                answer {
                    id
                    hashKey
                    name
                    description
                    dynamicName
                    dynamicDescription
                    displayName
                    displayDescription
                    displayMode
                    headlineVisibilityMap {
                        columnId
                        isVisible
                    }
                    queryableDataSource
                }
                refAnswer @client
            }
        `,
    );
    return {
        answer: cachedAnswerSession?.answer,
        refAnswer: cachedAnswerSession?.refAnswer,
    };
};

export const getAnswerMetadataFromCache = (
    cache: any,
    answerSessionId: string,
) => {
    const cachedAnswerSession = getCachedAnswer(
        cache,
        answerSessionId,
        gql`
            {
                id {
                    sessionId
                    genNo
                    acSession {
                        sessionId
                        genNo
                    }
                }
                answer {
                    id
                    name
                    description
                }
            }
        `,
    );
    return {
        answer: cachedAnswerSession,
    };
};

export const getCachedMetadataForAnswer = (answerSessionId: string) => {
    const { cache } = useApolloClient();
    return getAnswerMetadataFromCache(cache, answerSessionId);
};

export const getCachedPhrasesForAnswer = (answerSessionId: string) => {
    const { cache } = useApolloClient();
    const cachedAnswerSession = getCachedAnswer(
        cache,
        answerSessionId,
        gql`
            {
                id {
                    genNo
                }
                answer {
                    phrases {
                        ...phrase
                    }
                    visualizations {
                        __typename
                        id
                    }
                    displayMode
                }
            }
            ${PhraseFragmentDoc}
        `,
    );

    const displayMode = cachedAnswerSession?.answer
        .displayMode as keyof typeof displayTypes;

    const displayedVizId = cachedAnswerSession?.answer.visualizations.find(
        /* eslint-disable-next-line no-underscore-dangle */
        (viz: any) => viz.__typename === displayTypes[displayMode],
    );

    return {
        phrases: cachedAnswerSession?.answer?.phrases,
        displayedVizId: displayedVizId?.id,
    };
};

export const isAnswerMutationInProgress = (answerSessionId: string) => {
    const { data } = useBachQuery<
        GetIsAnswerMutationInProgressQuery,
        GetIsAnswerMutationInProgressQueryVariables
    >(answerSessionId, GetIsAnswerMutationInProgressDocument, {
        fetchPolicy: 'cache-only',
    });

    return data?.getAnswer?.answer?.isMutationInProgress;
};

export const setIsAnswerMutationInProgress = (
    client: ApolloClient<object>,
    answerSessionId: string,
    isMutationInProgress: boolean,
) => {
    const { cache } = client;
    const cachedAnswer = getCachedAnswer(
        cache,
        answerSessionId,
        gql`
            {
                answer {
                    id
                }
            }
        `,
    );

    cache.writeFragment({
        id: cache.identify(cachedAnswer.answer),
        fragment: gql`
            fragment isMutationInProgress on Answer {
                isMutationInProgress @client
            }
        `,
        data: {
            isMutationInProgress,
        },
    });
};

export const isVizPropChanged = (
    cache: ApolloCache<object>,
    answerSessionId: string,
) => {
    const cachedAnswerSession = getCachedAnswer(
        cache,
        answerSessionId,
        gql`
            {
                answer {
                    id
                    isVizPropUpdated @client
                }
            }
        `,
    );
    return cachedAnswerSession?.answer.isVizPropUpdated;
};

export const isUserAction = (
    cache: ApolloCache<object>,
    answerSessionId: string,
) => {
    const cachedAnswerSession = getCachedAnswer(
        cache,
        answerSessionId,
        gql`
            {
                answer {
                    id
                    isUserAction @client
                }
            }
        `,
    );
    return cachedAnswerSession?.answer.isUserAction;
};

export const setIsVizPropUpdatedState = (
    client: ApolloClient<object>,
    answerSessionId: string,
    isClientStateUpdated: boolean,
) => {
    const { cache } = client;
    const cachedAnswer = getCachedAnswer(
        cache,
        answerSessionId,
        gql`
            {
                answer {
                    id
                }
            }
        `,
    );
    cache.writeFragment({
        id: cache.identify(cachedAnswer.answer),
        fragment: gql`
            fragment vizUpdated on Answer {
                isVizPropUpdated @client
            }
        `,
        data: {
            isVizPropUpdated: isClientStateUpdated,
        },
    });
};

export const setIsVizPropUpdatedWithUserActionState = (
    client: ApolloClient<object>,
    answerSessionId: string,
    isClientStateUpdated: boolean,
    isUserAction: boolean,
) => {
    const { cache } = client;
    const cachedAnswer = getCachedAnswer(
        cache,
        answerSessionId,
        gql`
            {
                answer {
                    id
                }
            }
        `,
    );

    cache.writeFragment({
        id: cache.identify(cachedAnswer.answer),
        fragment: gql`
            fragment vizUpdated on Answer {
                isVizPropUpdated @client
                isUserAction @client
            }
        `,
        data: {
            isVizPropUpdated: isClientStateUpdated,
            isUserAction,
        },
    });
};

/**
 *
 * @param client - apollo client object
 * @param answerSessionId
 * @param isVizPropUpdated
 * @param isUserAction
 * @param needToUpdateGenNumber
 * @description - this is helpful for knowing we need to display unsaved changes popup for client state
 */

export const updateVizPropWithUserActionForRefAnswer = (
    client: ApolloClient<object>,
    answerSessionId: string,
    isVizPropUpdated: boolean,
    isUserAction: boolean,
    needToUpdateGenNumber?: boolean,
) => {
    const { cache } = client;
    const cachedAnswer = getCachedAnswerForHasUnsavedChanges(
        cache,
        answerSessionId,
    );

    // we need to set isUserAction along with VizProp Updated to show the unsaved pop up correctly
    // as vizProp can be updated by sytem as well instead of user hence the pop up shows up incorrectly
    // we need to maintain viz prop is updated or not for new answer as well as
    // save answer, so on the basis of it we can call saveVizProp mutation
    setIsVizPropUpdatedWithUserActionState(
        client,
        answerSessionId,
        isVizPropUpdated,
        isUserAction,
    );

    if (!cachedAnswer.refAnswer) {
        return;
    }
    const updatedRefAnswer: any = {
        ...cachedAnswer.refAnswer,
        isVizPropUpdated,
        isUserAction,
    };
    if (needToUpdateGenNumber) {
        const session = getSession(
            client,
            answerSessionId,
            'BachSessionId',
            bachSessionWithAcSessionKeyQuery,
            ['acSession'],
        );
        updatedRefAnswer.genNo = session.genNo;
    }

    cache.writeFragment({
        id: getAnswerCacheKey(cache, answerSessionId),
        fragment: gql`
            fragment refAnswer on AnswerEditSession {
                refAnswer @client
            }
        `,
        data: {
            refAnswer: updatedRefAnswer,
        },
    });
};

export const updateRefAnswerForUnsavedChanges = (
    client: ApolloClient<object>,
    answerSessionId: string,
    isVizPropUpdated: boolean,
) => {
    const { cache } = client;
    const { answer } = getCachedAnswerForHasUnsavedChanges(
        cache,
        answerSessionId,
    );
    // we need to maintain viz prop is updated or not for new answer as well as
    // save answer, so on the basis of it we can call saveVizProp mutation
    setIsVizPropUpdatedState(client, answerSessionId, isVizPropUpdated);

    const session = getSession(
        client,
        answerSessionId,
        'BachSessionId',
        bachSessionWithAcSessionKeyQuery,
        ['acSession'],
    );
    cache.writeFragment({
        id: getAnswerCacheKey(cache, answerSessionId),
        fragment: gql`
            fragment refAnswer on AnswerEditSession {
                refAnswer @client
            }
        `,
        data: {
            refAnswer: {
                hashKey: answer?.hashKey,
                name: answer?.name,
                description: answer?.description,
                dynamicName: answer?.dynamicName,
                dynamicDescription: answer?.dynamicDescription,
                displayName: answer?.displayName,
                displayDescription: answer?.displayDescription,
                genNo: session.genNo,
                isVizPropUpdated,
            },
        },
    });
};

export const updateVizCacheLocally = (
    client: ApolloClient<object>,
    answerSessionId: string,
    viz: ChartViz | TableViz | HeadlineViz | RAnalysisViz,
    clientState: ChartVizProps | TableVizProps | HeadlineVizProps,
    isUserAction: boolean, // updated variable name for better understanding
    updatedData?: any[],
) => {
    const { cache } = client;
    try {
        /* eslint-disable-next-line no-underscore-dangle */
        if (viz.__typename === 'ChartViz') {
            cache.modify({
                id: cache.identify({
                    id: viz.id,
                    /* eslint-disable-next-line no-underscore-dangle */
                    __typename: viz.__typename,
                }),
                fields: {
                    data(cachedData) {
                        return updatedData || cachedData;
                    },
                    vizProp() {
                        return clientState;
                    },
                    config(cachedConfig) {
                        return {
                            ...cachedConfig,
                            isLocked: cachedConfig.isLocked || isUserAction, // if it is a user action we lock the chart.
                        };
                    },
                },
            });
        } else {
            cache.modify({
                id: cache.identify({
                    id: viz.id,
                    /* eslint-disable-next-line no-underscore-dangle */
                    __typename: viz.__typename,
                }),
                fields: {
                    vizProp() {
                        return clientState;
                    },
                },
            });
        }
    } catch (error) {
        if (!error?.message?.includes('already recomputing')) {
            throw error;
        }
    }

    updateVizPropWithUserActionForRefAnswer(
        client,
        answerSessionId,
        true,
        isUserAction,
    );
};

export const useCreateAnswerSessionMutation = (
    onComplete: (session: BachSessionId, answerId: string) => void,
    sources: string[] = [],
    useLastSelectedSources = true,
    dataPaginationParams?: DataPaginationParamsInput,
    answerContext?: AnswerContextType,
) => {
    const runtimeParams = useRuntimeParams();

    return useCreateAnswer({
        variables: {
            sources,
            useLastSelectedSources,
            runtimeFilter: runtimeParams.runtimeFilter,
            runtimeSort: runtimeParams.runtimeSort,
            runtimeParameter: runtimeParams.runtimeParameters,
            ...(!_.isNil(answerContext) ? { answerContext } : {}),
        },
        update: (cache, result) => {
            const bachSession = result.data.Answer__create.id;
            const answerId = result.data.Answer__create?.answer?.id;
            onComplete(bachSession, answerId);
        },
    });
};

/**
 * Shared hook for fullscreen modal dialogs (cohort, input table, etc.) that need to
 * create a new answer session on open. Encapsulates the common session creation pattern
 * so each modal container doesn't have to duplicate this boilerplate.
 */
export const useCreateModalAnswerSession = (
    initialDataSourceIds: string[],
    answerContext: AnswerContextType = AnswerContextType.CohortAnswer,
) => {
    const [answerSessionId, setAnswerSessionId] = React.useState<string | null>(
        null,
    );
    const [answerId, setAnswerId] = React.useState<string | null>(null);
    const isMountedRef = React.useRef(true);

    const [
        createAnswer,
        { data, loading, error },
    ] = useCreateAnswerSessionMutation(
        (session: BachSessionId, ansId: string) => {
            if (isMountedRef.current) {
                setAnswerSessionId(session.sessionId);
                setAnswerId(ansId);
            }
        },
        initialDataSourceIds,
        false,
        {
            isClientPaginated: true,
            size: envFlags.getValue(FLAGS.dataBatchSize?.name) ?? 1000,
            offset: 0,
        },
        answerContext,
    );

    React.useEffect(() => {
        isMountedRef.current = true;
        createAnswer();
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    return {
        answerSessionId,
        answerId,
        data: data?.Answer__create?.answer as Answer,
        loading,
        error,
    };
};

export const useLoadAnswerSessionMutation = (
    id: string,
    onComplete: (sessionId: string, answerName?: string) => void,
    isSavedView = false,
    dataPaginationParams: DataPaginationParamsInput,
    answerContext?: AnswerContextType,
    handledErrors?: BlinkErrorCode[],
    overrideParsedQueryParams?: ParsedQs,
    parentSession?: BachSessionIdInput,
) => {
    const client = useApolloClient();
    const runtimeParams = useRuntimeParams(overrideParsedQueryParams);

    const [loadAnswer, { loading, data, error }] = useLoadAnswer({
        update: (cache, result) => {
            const answerSessionId = result.data.Answer__load.id.sessionId;
            onComplete(answerSessionId, result.data.Answer__load.answer.name);
            updateRefAnswerForUnsavedChanges(client, answerSessionId, false);
        },
        variables: {
            id,
            isSavedView,
            runtimeFilter: runtimeParams.runtimeFilter,
            runtimeSort: runtimeParams.runtimeSort,
            runtimeParameter: runtimeParams.runtimeParameters,
            answerContext,
            parentSession,
        },
        refetchQueries: result => {
            return refetchVizData(client, result);
        },
        awaitRefetchQueries: true,
        handledErrors,
    });
    return {
        loadAnswer,
        loading,
        error,
        data: data?.Answer__load.answer,
    };
};

export const useLoadCopiedAnswerFromId = (
    id: string,
    onComplete: (sessionId: string) => void,
    dataPaginationParams: DataPaginationParamsInput,
) => {
    const client = useApolloClient();
    const [
        loadCopiedAnswerFromId,
        { loading, data, error },
    ] = useLoadCopiedAnswerFromIdMutation({
        update: (cache, result) => {
            onComplete(result.data.Answer__CopyFromId.id.sessionId);
        },
        variables: {
            id,
        },
        refetchQueries: result => {
            return refetchVizData(client, result);
        },
        awaitRefetchQueries: true,
    });

    return {
        loadCopiedAnswerFromId,
        loading,
        error,
        data: data?.Answer__CopyFromId.answer,
    };
};

export const useGetAnswerQuery = (answerSessionId: string) => {
    const { data, error, loading, refetch } = useBachQuery<
        GetAnswerQuery,
        GetAnswerQueryVariables
    >(answerSessionId, GetAnswerDocument, {
        skip: !answerSessionId,
        fetchPolicy: 'cache-only',
    });
    const client = useApolloClient();

    let cachedAnswer = data?.getAnswer?.answer;

    if (
        cachedAnswer?.visualizations?.length === 0 &&
        fetchVizRefsForAnswerSession(client.cache, answerSessionId).length
    ) {
        // data from apollo cache is not mutatable so we will clone it
        cachedAnswer = _.cloneDeep(cachedAnswer);
        const cachedChartViz = readFromLBChartVizCache(answerSessionId)
            ?.chartViz;
        if (cachedChartViz) {
            cachedAnswer.visualizations.push(cachedChartViz);
        }
    }

    return {
        answer: cachedAnswer,
        error,
        loading,
        refetch,
    };
};

export const useGetInsightDataQuery = (
    answerSessionId: string,
    answerId: string,
) => {
    const { data, error, loading, refetch } = useBachQuery<
        GetInsightDataQuery,
        GetInsightDataQueryVariables
    >(answerSessionId, GetInsightDataDocument, {
        variables: {
            answerId,
        } as GetInsightDataQueryVariables,
        skip: !answerSessionId || !answerId,
    });

    return {
        insightData: data?.getInsightData,
        error,
        loading,
        refetch,
    };
};

export const useSaveWhatIfScenarioMutation = (answerSessionId: string) => {
    const [_saveWhatIfScenario, { loading, error, data }] = useBachMutation<
        SaveWhatIfScenarioMutation,
        SaveWhatIfScenarioMutationVariables
    >(answerSessionId, SaveWhatIfScenarioDocument);

    const saveWhatIfScenario = (insightId: string, scenario: ScenarioInput) => {
        return _saveWhatIfScenario({
            variables: {
                insightId,
                scenario,
            },
        });
    };

    return {
        saveWhatIfScenario,
        loading,
        error,
    };
};

export const useCopyAnswerSessionMutation = (answerSessionId: string) => {
    const [_copyAnswer, { loading, error, data }] = useBachMutation<
        CopyAnswerMutation,
        CopyAnswerMutationVariables
    >(answerSessionId, CopyAnswerDocument);

    const copyAnswer = (
        name: string,
        description: string,
        dynamicName?: string,
        dynamicDescription?: string,
    ) => {
        const variables = {
            name,
            description,
        } as CopyAnswerMutationVariables;
        if (dynamicName) {
            variables.dynamicName = dynamicName;
        }
        if (dynamicDescription) {
            variables.dynamicDescription = dynamicDescription;
        }
        return _copyAnswer({
            variables,
        });
    };

    return {
        copyAnswer,
        loading,
        error,
        copiedBachSessionId: data?.Answer__copy,
    };
};

export const useGetUnAggregatedAnswer = (answerSessionId: string) => {
    const client = useApolloClient();
    // Gated so the mutation is deferred until the pinboard session is fully
    // hydrated, preventing it from firing against a stale pre-hydration session.
    // Secondary Action: Show underlying data
    const [
        _getUnAggregatedAnswer,
        { data, loading, error },
    ] = useGatedBachMutation<
        GetUnAggregatedAnswerSessionMutation,
        GetUnAggregatedAnswerSessionMutationVariables
    >(answerSessionId, GetUnAggregatedAnswerSessionDocument);

    const getUnAggregatedAnswer = (
        columns: UserPointSelectionInput[],
        onComplete: (sessionId: string) => void,
    ) => {
        return _getUnAggregatedAnswer({
            variables: {
                columns,
            },
            update: (cache, result) => {
                onComplete(
                    result.data.Answer__getUnaggregatedAnswer.id.sessionId,
                );
            },
            refetchQueries: result => {
                return refetchVizData(client, result);
            },
            awaitRefetchQueries: true,
        });
    };

    return {
        getUnAggregatedAnswer,
        answer: data?.Answer__getUnaggregatedAnswer.id.sessionId,
        loading,
        error,
    };
};

export const useGetAnswerFromTokensMutation = (answerSessionId: string) => {
    const [getAnswer, { data, loading, error }] = useBachMutation<
        GetAnswerFromTokensMutation,
        GetAnswerFromTokensMutationVariables
    >(answerSessionId, GetAnswerFromTokensDocument, {
        shouldRefetchData: true,
    });

    return {
        getAnswer,
        data: data?.getAnswerFromTokens.answer,
        loading,
        error,
    };
};

export const useGetAnswerSessionQuery = (answerSessionId: string) => {
    const { data, error, loading } = useBachQuery<
        GetAnswerSessionQuery,
        GetAnswerSessionQueryVariables
    >(answerSessionId, GetAnswerSessionDocument);
    return {
        error,
        data: data?.getAnswer.id,
    };
};

export const useHasVisualizationsQuery = (answerSessionId: string) => {
    const client = useApolloClient();

    const { data, error, loading } = useBachQuery<
        HasVisualizationsQuery,
        HasVisualizationsQueryVariables
    >(answerSessionId, HasVisualizationsDocument, { skip: !answerSessionId });
    const cachedAnswer = data?.getAnswer?.answer;
    const loadingState = cachedAnswer?.visualizationsLoading;
    let visualizations = cachedAnswer?.visualizations;

    // In case of liveboard load, we evict the chart viz cache from apollo cache
    // and store in local cache to avoid memory bloat by apollo watchers
    // Any component that needs chart viz will read from local cache
    if (
        loadingState &&
        visualizations &&
        _.isEmpty(visualizations) &&
        fetchVizRefsForAnswerSession(client.cache, answerSessionId).length
    ) {
        const chartVizCache = readFromLBChartVizCache(answerSessionId)
            ?.chartViz;
        visualizations = chartVizCache ? [chartVizCache] : [];
    }
    const hasChart = visualizations
        ? visualizations.some(
              /* eslint-disable-next-line no-underscore-dangle */
              viz => viz.__typename === 'ChartViz',
          )
        : false;
    const displayMode = cachedAnswer?.displayMode;

    return {
        error,
        loadingState,
        hasVisualizations: !_.isEmpty(visualizations),
        hasChart,
        displayMode,
        loading,
    };
};

/**
 * Return true if we should remap bach error code to SAGE_INDEXING ('9505')
 * which is a Blink-generated error code. In this case, we show the banner alert:
 * "Still indexing this data, please try again later." to user.
 *
 * (for ADD COLUMNS mutation only)
 */
export const shouldRemapToSageIndexingError = (error: ApolloError): boolean => {
    const errObj = !(error?.networkError as any)?.result?.errors?.[0]
        ? (error?.graphQLErrors?.[0] as any)
        : (error?.networkError as any)?.result?.errors?.[0];
    if (errObj?.extensions?.service === 'BACH') {
        /**
         * Bach errors use a generic bach error code.
         * So we need to check sourceErrorDetail object to get more details about
         * the underlying error from Sage.
         *
         * Example sourceErrorDetail object:
         * { errorCode: "18"
         *   errorMessage: ""
         *   errorName: "NOT_FOUND"
         *   source: "SAGE" }
         */
        const sourceErrorDetail = errObj?.extensions?.sourceErrorDetail;
        return (
            sourceErrorDetail?.source === 'SAGE' &&
            (sourceErrorDetail?.errorName === 'NOT_FOUND' ||
                sourceErrorDetail?.errorName === 'NO_MATCH')
        );
    }
    return false;
};

export const useAddColumnsMutation = (
    answerSessionId: string,
    updateOnlyPhrases = false,
    setVisualizationsLoading = false,
    setPhrasesLoading = true,
    shouldRefetchData = false,
    customRefetchQueriesFn?: any,
) => {
    if (!updateOnlyPhrases) {
        // eslint-disable-next-line no-param-reassign
        setVisualizationsLoading = true;
        // eslint-disable-next-line no-param-reassign
        shouldRefetchData = true;
    }
    const [addColumns, { data, error, loading }] = useBachMutation<
        AddColumnsMutation,
        AddColumnsMutationVariables
    >(
        answerSessionId,
        AddColumnsDocument,
        {
            setVisualizationsLoading,
            setPhrasesLoading,
            shouldRefetchData,
            customRefetchQueriesFn,
        },
        undefined,
        undefined,
        true, // This can be called after editing sage query but not updating answer yet
    );

    /**
     * This error-remapping is a HACK to show Sage indexing banner alert
     * when add columns mutation fails due to the data source still indexing.
     *
     * The assumption is that: If the user can see the column in left panel,
     * but if Sage returns either NO_MATCH or NO_FOUND for that column,
     * it must be due to data still indexing.
     *
     * We need this hack in front-end because Sage currently does not know if
     * a data source is still indexing or not, and thus cannot send "still indexing"
     * error code to front-end.
     */
    if (shouldRemapToSageIndexingError(error)) {
        const originalErr = !(error?.networkError as any)?.result?.errors?.[0]
            ? (error?.graphQLErrors?.[0] as any)
            : (error?.networkError as any)?.result?.errors?.[0];
        if (originalErr && originalErr?.extensions?.code) {
            originalErr.extensions.code =
                blinkConstants.blinkGeneratedErrors.SAGE_INDEXING;
        }
    }

    /**
     * This error-mapping is to show JoinPathAmbiguity banner alert
     * when add columns mutation fails. Because this error is issued by Prism rather than Bach,
     * we must map it to the appropriate message code.
     */
    if (shouldRemapToJoinPathAmbiguityError(error)) {
        mapJoinPathAmbiguityErrorCode(error);
    }

    return {
        data,
        error,
        loading,
        addColumns: React.useCallback(
            (ids: string[]) => {
                return addColumns({
                    variables: {
                        columns: ids.map(id => ({
                            logicalColumnId: id,
                        })),
                        updateOnlyPhrases,
                    },
                });
            },
            [addColumns, updateOnlyPhrases],
        ),
    };
};

/**
 * - removeLogicalColumnId: removes all the manifestations of a logical column
 *   from the answer. (e.g. formulas, filters based on that column)
 *
 * - removeColumnId: removes only that particular column from the answer
 */
export const useRemoveColumnMutation = (
    answerSessionId: string,
    updateOnlyPhrases = false,
    setVisualizationsLoading = false,
    setPhrasesLoading = true,
    shouldRefetchData = false,
) => {
    if (!updateOnlyPhrases) {
        // eslint-disable-next-line no-param-reassign
        setVisualizationsLoading = true;
        // eslint-disable-next-line no-param-reassign
        shouldRefetchData = true;
    }
    const [removeColumn, { data, error, loading }] = useBachMutation<
        RemoveColumnMutation,
        RemoveColumnMutationVariables
    >(
        answerSessionId,
        RemoveColumnDocument,
        {
            setVisualizationsLoading,
            setPhrasesLoading,
            shouldRefetchData,
        },
        undefined,
        undefined,
        true, // This can be called after editing sage query but not updating answer yet
    );

    const removeLogicalColumnId = React.useCallback(
        (logicalColumnId: string) => {
            return removeColumn({
                variables: {
                    logicalColumnId,
                    updateOnlyPhrases,
                },
            });
        },
        [removeColumn, updateOnlyPhrases],
    );

    const removeColumnId = React.useCallback(
        (columnId: string) => {
            return removeColumn({
                variables: {
                    columnId,
                    updateOnlyPhrases,
                },
            });
        },
        [removeColumn, updateOnlyPhrases],
    );

    return {
        data,
        error,
        loading,
        removeLogicalColumnId,
        removeColumnId,
    };
};

export const useRemoveColumnsMutation = (
    answerSessionId: string,
    setVisualizationsLoading = true,
    setPhrasesLoading = true,
    shouldRefetchData = true,
    updateOnlyPhrases = false,
    customRefetchQueriesFn?: any,
) => {
    if (!updateOnlyPhrases) {
        // eslint-disable-next-line no-param-reassign
        setVisualizationsLoading = true;
        // eslint-disable-next-line no-param-reassign
        shouldRefetchData = true;
    }
    const [removeColumns, { data, loading, error }] = useBachMutation<
        RemoveColumnsMutation,
        RemoveColumnsMutationVariables
    >(
        answerSessionId,
        RemoveColumnsDocument,
        {
            setVisualizationsLoading,
            setPhrasesLoading,
            shouldRefetchData,
            customRefetchQueriesFn,
        },
        undefined,
        undefined,
        true, // This can be called after editing sage query but not updating answer yet
    );

    return {
        loading,
        data,
        error,
        removeColumnIds: (ids: string[]) => {
            return removeColumns({
                variables: {
                    columnIds: ids,
                    updateOnlyPhrases,
                },
            });
        },
        removeLogicalColumnIds: (ids: string[]) => {
            return removeColumns({
                variables: {
                    logicalColumnIds: ids,
                    updateOnlyPhrases,
                },
            });
        },
    };
};

export const useAddAndRemoveColumnMutation = (
    answerSessionId: string,
    setVisualizationsLoading = true,
    setPhrasesLoading = true,
    shouldRefetchData = true,
    updateOnlyPhrases = false,
    customRefetchQueriesFn?: any,
) => {
    if (!updateOnlyPhrases) {
        // eslint-disable-next-line no-param-reassign
        setVisualizationsLoading = true;
        // eslint-disable-next-line no-param-reassign
        shouldRefetchData = true;
    }
    const [_addAndRemoveColumn, { data, loading, error }] = useBachMutation<
        AddAndRemoveColumnMutation,
        AddAndRemoveColumnMutationVariables
    >(
        answerSessionId,
        AddAndRemoveColumnDocument,
        {
            setVisualizationsLoading,
            setPhrasesLoading,
            shouldRefetchData,
            customRefetchQueriesFn,
        },
        undefined,
        undefined,
        true,
    );

    return {
        loading,
        data,
        error,
        addAndRemoveColumn: (
            columnToAdd: AnswerColumnInfo[],
            columnIdToRemove: string,
        ) => {
            return _addAndRemoveColumn({
                variables: {
                    columnsToAdd: columnToAdd,
                    columnIdToRemove,
                    updateOnlyPhrases,
                },
            });
        },
    };
};

export const useUpdateColumnMutation = (
    answerSessionId: string,
    isPhraseLoadingNeeded = true,
) => {
    return useBachMutation<UpdateColumnMutation, UpdateColumnMutationVariables>(
        answerSessionId,
        UpdateColumnDocument,
        {
            setVisualizationsLoading: true,
            setPhrasesLoading: isPhraseLoadingNeeded,
            shouldRefetchData: true,
        },
    );
};

export const useUpdateColumnNameMutation = (
    answerSessionId: string,
    isPhraseLoadingNeeded = true,
) => {
    const client = useApolloClient();
    const [renameColumn] = useBachMutation<
        RenameColumnMutation,
        RenameColumnMutationVariables
    >(answerSessionId, RenameColumnDocument);
    return {
        renameColumn: ({
            variables,
            answerId,
            viz,
            shouldOptimisticResponse = true,
        }: AnswerColumnRenameParam) => {
            return renameColumn({
                variables,
                optimisticResponse: shouldOptimisticResponse && {
                    __typename: 'Mutation',
                    [AnswerColumnOptimisicResKey]: getOptimisticResponseForColumn(
                        client,
                        answerSessionId,
                        answerId,
                        viz,
                        {
                            columnId: variables.columnId,
                            name: variables.name,
                            dynamicTitle: variables.dynamicTitle || null,
                        },
                    ),
                },
            }).then(result => {
                // Evict GetAnswerDataByQuery cache after mutation completes
                // This ensures chart data will be refetched with updated column names
                // when next requested, without triggering immediate refetch
                evictAnswerDataByQueryCache(client);
                return result;
            });
        },
    };
};

export const useUpdateSortMutation = (
    answerSessionId: string,
    setPhrasesLoading = true,
    setVisualizationsLoading = true,
    shouldRefetchData = true,
    customRefetchQueriesFn?: any,
) => {
    return useGatedBachMutation<
        UpdateSortMutation,
        UpdateSortMutationVariables
    >(answerSessionId, UpdateSortDocument, {
        setVisualizationsLoading,
        setPhrasesLoading,
        shouldRefetchData,
        customRefetchQueriesFn,
    });
};

export const useGetColumnValuesMutation = (answerSessionId: string) => {
    const [
        getUniqueColumnDataByColumnId,
        { data, error, loading },
    ] = useBachMutation<
        GetColumnValuesMutation,
        GetColumnValuesMutationVariables
    >(
        answerSessionId,
        GetColumnValuesDocument,
        undefined,
        undefined,
        undefined,
        true,
    );

    const jsonEncodedValues: string | undefined =
        data?.Answer__getUniqueColumnValues?.values;

    let columnValuesList: string[] = [];
    columnValuesList = parseColumnValues(jsonEncodedValues);

    return {
        getUniqueColumnDataByColumnId,
        columnValuesData: columnValuesList,
        error,
        loading,
    };
};

export const useSetSourcesMutation = (
    answerSessionId: string,
    updateEmptyPageState?: (val: EmptyAnswer) => void,
) => {
    const [_setSources, { data, error, loading }] = useBachMutation<
        SetSourcesMutation,
        SetSourcesMutationVariables
    >(
        answerSessionId,
        SetSourcesDocument,
        {
            setPhrasesLoading: true,
        },
        undefined,
        undefined,
        true,
    );

    const setSources = React.useCallback(
        (ids: string[], forceSelect = false) =>
            _setSources({
                variables: {
                    sources: ids,
                    updateLastSelectedSource: true,
                    forceSelect,
                },
                update: (cache, result) => {
                    if (
                        updateEmptyPageState &&
                        result?.data?.Answer__setDataSources?.emptyAnswer
                    ) {
                        updateEmptyPageState(
                            result.data.Answer__setDataSources.emptyAnswer,
                        );
                    }
                },
            }),
        [updateEmptyPageState],
    );

    return {
        data,
        error,
        loading,
        setSources,
    };
};

export const useClearAnswerAndSetSourcesMutation = (
    answerSessionId: string,
    updateEmptyPageState?: (val: EmptyAnswer) => void,
) => {
    const [
        _clearAnswerAndSetSources,
        { data, error, loading },
    ] = useBachMutation<
        ClearAnswerAndSetSourcesMutation,
        ClearAnswerAndSetSourcesMutationVariables
    >(answerSessionId, ClearAnswerAndSetSourcesDocument, {
        setPhrasesLoading: true,
    });

    const clearAnswerAndSetSources = React.useCallback(
        (ids: string[]) =>
            _clearAnswerAndSetSources({
                variables: {
                    sources: ids,
                    updateLastSelectedSource: true,
                },
                update: (cache, result) => {
                    if (
                        updateEmptyPageState &&
                        result?.data?.Answer__clearAnswerAndSetSources
                            ?.emptyAnswer
                    ) {
                        updateEmptyPageState(
                            result.data.Answer__clearAnswerAndSetSources
                                .emptyAnswer,
                        );
                    }
                },
            }),
        [updateEmptyPageState],
    );
    return {
        clearAnswerAndSetSources,
        data,
        error,
        loading,
    };
};

export const useGetAnswerTitleQuery = (answerSessionId: string) => {
    const { data, error, loading } = useBachQuery<
        GetAnswerTitleQuery,
        GetAnswerTitleQueryVariables
    >(answerSessionId, GetAnswerTitleDocument, { skip: !answerSessionId });
    return {
        data: data?.getAnswer.answer,
        error,
        loading,
    };
};

export const useGetAnswerTitleLazyQuery = (answerSessionId: string) => {
    const [getTitle, { data, error, loading }] = useBachLazyQuery<
        GetAnswerTitleQuery,
        GetAnswerTitleQueryVariables
    >(answerSessionId, GetAnswerTitleDocument);
    return {
        getTitle,
        data: data?.getAnswer.answer,
        error,
        loading,
    };
};

export const useUpdateAnswerTitleMutation: (
    answerSessionId: string,
) => [
    (
        payload: Partial<
            Pick<
                Answer,
                | 'name'
                | 'dynamicName'
                | 'description'
                | 'dynamicDescription'
                | 'displayName'
                | 'displayDescription'
            >
        >,
    ) => Promise<void>,
    MutationResult<UpdateAnswerTitleMutation>,
] = answerSessionId => {
    const client = useApolloClient();

    const [_updateAnswerTitleDescription, _state] = useBachMutation<
        UpdateAnswerTitleMutation,
        UpdateAnswerTitleMutationVariables
    >(
        answerSessionId,
        UpdateAnswerTitleDocument,
        {
            onCompleted: data => {
                setIsAnswerMutationInProgress(client, answerSessionId, false);
                // Update cache with new genNo after answer settings mutation
                updateVizPropWithUserActionForRefAnswer(
                    client,
                    answerSessionId,
                    false,
                    false,
                    true, // needToUpdateGenNumber = true
                );
            },
            onError: () => {
                setIsAnswerMutationInProgress(client, answerSessionId, false);
            },
        },
        undefined,
        false,
        true,
    );
    const [cancelableMutation, abortController, state] = useCancelableMutation([
        _updateAnswerTitleDescription,
        _state,
    ]);

    const updateAnswerTitleDescription = async (
        payload: Partial<
            Pick<
                Answer,
                | 'name'
                | 'dynamicName'
                | 'description'
                | 'dynamicDescription'
                | 'displayName'
                | 'displayDescription'
            >
        >,
    ) => {
        const answer = getAnswerMetadataForAnswerEditSession(
            client.cache,
            answerSessionId,
        );

        setIsAnswerMutationInProgress(client, answerSessionId, true);
        await cancelableMutation({
            variables: _.pickBy(payload, v => !_.isNil(v)),
            optimisticResponse: {
                __typename: 'Mutation',
                [AnswerDisplayModeMutation]: getOptimisiticResponseForAnswerTitleDescription(
                    _state.client,
                    answerSessionId,
                    answer.id,
                    payload,
                ),
            },
        });
    };

    return [updateAnswerTitleDescription, state];
};

const isVizDataPresentForDisplayMode = (
    client: ApolloClient<Record<string, any>>,
    answer: Answer,
    displayMode: DisplayMode,
) => {
    const cacheData = client.cache.extract();
    const cachedAnswer =
        cacheData[
            client.cache.identify({
                /* eslint-disable-next-line no-underscore-dangle */
                __typename: 'Answer',
                id: answer?.id,
            })
        ];
    const vizRefs = (cachedAnswer?.visualizations as Reference[]) || [];
    const isVizAvailable = vizRefs.length
        ? vizRefs.every(ref => {
              /* eslint-disable-next-line no-underscore-dangle */
              const viz = cacheData[ref.__ref];
              if (displayMode === DisplayMode.ChartMode) {
                  /* eslint-disable-next-line no-underscore-dangle */
                  if (viz.__typename === 'ChartViz') {
                      return !_.isNil(viz?.data);
                  }
                  return true;
              }
              if (displayMode === DisplayMode.TableMode) {
                  /* eslint-disable-next-line no-underscore-dangle */
                  if (viz.__typename === 'TableViz') {
                      return !_.isNil(viz?.data);
                  }
                  return true;
              }
              if (displayMode === DisplayMode.RAnalysisMode) {
                  /* eslint-disable-next-line no-underscore-dangle */
                  if (viz.__typename === 'RAnalysisViz') {
                      return !_.isNil(viz?.data);
                  }
                  return true;
              }
              return false;
          })
        : false;
    return isVizAvailable;
};

export const useUpdateDisplayModeMutation = (answerSessionId: string) => {
    const client = useApolloClient();
    const [updateDisplayMode] = useBachMutation<
        UpdateDisplayModeMutation,
        UpdateDisplayModeMutationVariables
    >(
        answerSessionId,
        UpdateDisplayModeDocument,
        {
            setVisualizationsLoading: false,
        },
        undefined,
        false,
        true,
    );

    return async (
        newDisplayMode: DisplayMode,
        loadVizForCustomChart = false,
        visualOverrides?: VisualOverridesPayloadInput,
    ) => {
        const answer = getAnswerMetadataForAnswerEditSession(
            client.cache,
            answerSessionId,
        );

        const param: BachMutationFunctionOptions<
            UpdateDisplayModeMutation,
            Omit<
                UpdateDisplayModeMutationVariables,
                'session' | 'dataPaginationParams'
            >
        > = {
            variables: {
                displayMode: newDisplayMode,
                ...(visualOverrides != null && { visualOverrides }),
            },
            setVisualizationsLoading:
                !isVizDataPresentForDisplayMode(
                    client,
                    answer,
                    newDisplayMode,
                ) || loadVizForCustomChart,
        };

        if (newDisplayMode === answer.displayMode) {
            // should not call mutation when clicking multiple times
            // this will also avoid cache corrupt issue when user clicking rapidly on switch display mode action
            // Continuously
            return Promise.resolve(null);
        }
        if (isVizDataPresentForDisplayMode(client, answer, newDisplayMode)) {
            param.optimisticResponse = {
                __typename: 'Mutation',
                [AnswerDisplayModeMutation]: getOptimisitResponseForDisplayMutation(
                    client,
                    answerSessionId,
                    answer.id,
                    newDisplayMode,
                ),
            };
        }
        try {
            const res = await updateDisplayMode(param);
            setVisualizationLoading(
                client,
                answerSessionId,
                res.errors ? LoadingState.Failure : LoadingState.Success,
            );
            // Update cache with new genNo after display mode mutation
            if (!res.errors) {
                updateVizPropWithUserActionForRefAnswer(
                    client,
                    answerSessionId,
                    false,
                    false,
                    true, // needToUpdateGenNumber = true
                );
            }
            return res;
        } catch (err) {
            logger.warn('Display mode api call failed', err);
            // when api call fails we need to handle visualization loading that time too
            setVisualizationLoading(
                client,
                answerSessionId,
                LoadingState.Failure,
            );
            return err;
        }
    };
};

export const getAllClientStateMutation = (
    queryName: string,
    visualizations: Visualization[],
    keepSession = true,
): CombinedQueryBuilder => {
    let chartType: ChartType;
    const containsChartViz: boolean = visualizations.some(
        (viz: ChartViz | TableViz | HeadlineViz | RAnalysisViz) => {
            /* eslint-disable-next-line no-underscore-dangle */
            if (viz.__typename === 'ChartViz') {
                chartType = viz?.config?.chartType;
            }
            /* eslint-disable-next-line no-underscore-dangle */
            return viz.__typename === 'ChartViz';
        },
    );
    const UpdateCustomVisualPropsDocument = gql`
        mutation UpdateCustomVisualProps(
            $sessionVisualPropUpdate: BachSessionIdInput!
            $chartVizId: GUID!
            $customVisualProps: JSON!
        ) {
            Answer__updateCustomVisualProps(
                session: $sessionVisualPropUpdate
                vizId: $chartVizId
                customVisualProps: $customVisualProps
            ) {
                id {
                    ...bachSession
                }
                answer {
                    id
                    orderedChips {
                        ...chip
                    }
                    parameters {
                        ...parameter
                    }
                    visualizations {
                        id
                        ... on ChartViz {
                            customVisualProps
                        }
                        ... on HeadlineViz {
                            vizProp {
                                ...headlineVizProps
                            }
                        }
                        ... on TableViz {
                            vizProp {
                                ...tableVizProps
                            }
                        }
                    }
                }
            }
            Answer__clearVisualOverrides(
                session: $sessionVisualPropUpdate
                vizId: $chartVizId
                clearOverrides: true
            ) {
                id {
                    ...bachSession
                }
                answer {
                    id
                    orderedChips {
                        ...chip
                    }
                    parameters {
                        ...parameter
                    }
                    visualizations {
                        id
                        ... on ChartViz {
                            visualOverrides {
                                ...chartVisualOverrides
                            }
                        }
                        ... on HeadlineViz {
                            vizProp {
                                ...headlineVizProps
                            }
                        }
                        ... on TableViz {
                            vizProp {
                                ...tableVizProps
                            }
                        }
                    }
                }
            }
        }
        ${ChartVisualOverridesFragmentDoc}
        ${HeadlineVizPropsFragmentDoc}
        ${TableVizPropsFragmentDoc}
        ${ChipFragmentDoc}
        ${ParameterFragmentDoc}
    `;
    let combineQueryDocument = combineQuery(queryName).addN(
        UpdateClientStateDocument,
        new Array(visualizations.length || 1).fill({}),
        {
            whiteListedTopLevelFieldsOnSelectionSet: ['id'],
        },
        (name: string, idx: number) =>
            keepSession && name === 'session' && idx === 0
                ? name
                : `${name}_${idx}`,
    );
    if (containsChartViz) {
        if (chartType && isCustomOrTsHostedChart(chartType))
            combineQueryDocument = combineQueryDocument.add(
                UpdateCustomVisualPropsDocument,
            );
        combineQueryDocument.add(UpdateChartConfigLockOnSaveDocument);
    }
    return combineQueryDocument;
};

export const getCachedVisualizations = (
    client: ApolloClient<object>,
    answerSessionId: string,
): Visualization[] => {
    const { cache } = client;
    if (!answerSessionId) return [];

    const cachedAnswer = getCachedAnswerVisualization(cache, answerSessionId);
    return cachedAnswer?.answer?.visualizations || [];
};

export const useUpdateAllVizProps = (
    client: ApolloClient<object>,
    answerSessionId: string,
    isAssociatedObjectMutationInFlightHook = () => false,
) => {
    const visualizations = getCachedVisualizations(client, answerSessionId);
    const {
        persistedVisualPropKeys,
        globalPersistedKeyVisualProp,
    } = getCustomChartContext();
    const { document } = (() =>
        getAllClientStateMutation('SaveVizProps', visualizations))();
    const [__saveVizProp, state] = useBachMutation(answerSessionId, document);
    const [
        _saveVizProp,
        { data, error, loading },
    ] = useWaitUntilNoMutationIsInFlightHook(
        [__saveVizProp, state],
        isAssociatedObjectMutationInFlightHook,
    );
    let updatedVisualProp: unknown;
    if (answerSessionId && answerSessionId !== '') {
        updatedVisualProp = getUpdatedCustomVisualProp(
            client,
            persistedVisualPropKeys,
            globalPersistedKeyVisualProp,
            answerSessionId,
        );
    }
    const saveVizProp = React.useCallback(
        async (
            updateRefAnswerGenNo = true,
            updatedVisualProps = updatedVisualProp,
        ) => {
            // Set flag to prevent adding new undo state for genNo update
            // This is a system action (saving viz props) and shouldn't create an undo entry
            setNextGenNoShouldReplaceCurrent(client, answerSessionId, true);

            try {
                const visualizations = getCachedVisualizations(
                    client,
                    answerSessionId,
                );
                const clientStateRequests = getClientStateRequest(
                    visualizations,
                    answerSessionId,
                    updatedVisualProps,
                );
                const result = await _saveVizProp({
                    variables: {
                        ...clientStateRequests,
                    },
                });
                updateVizPropWithUserActionForRefAnswer(
                    client,
                    answerSessionId,
                    false,
                    true, // passing isUserAction true as saveVizProp is getting called by user actions
                    updateRefAnswerGenNo,
                );
                return Promise.resolve(result);
            } finally {
                // Always reset the flag after mutation completes
                setNextGenNoShouldReplaceCurrent(
                    client,
                    answerSessionId,
                    false,
                );
            }
        },
        [answerSessionId],
    );
    return {
        saveVizProp,
        data,
        error,
        loading,
    };
};

export const useSaveAnswerAndClientStateMutation = (
    answerSessionId: string,
    answerId: string,
    onSaveAnswerAndClientStateComplete?: () => void,
) => {
    const client = useApolloClient();
    const { cache } = client;

    const {
        persistedVisualPropKeys,
        globalPersistedKeyVisualProp,
    } = getCustomChartContext();
    const bachAcHistoryContext = useBachAcHistoryContext();

    const cachedAnswer = getCachedAnswerVisualization(cache, answerSessionId);
    const visualizations: Visualization[] =
        cachedAnswer?.answer?.visualizations || [];
    const { document } = (() =>
        getAllClientStateMutation(
            'SaveAnswerAndUpdateVizProps',
            visualizations,
        ).add(SaveAnswerDocument))();
    const [_saveAnswer, { data, error, loading }] = useBachMutation<
        SaveAnswerMutation,
        SaveAnswerMutationVariables
    >(answerSessionId, document, {
        onCompleted: () => {
            bachAcHistoryContext.clearUndoStackAndUpdateResetTarget();
            updateRefAnswerForUnsavedChanges(client, answerSessionId, false);
            onSaveAnswerAndClientStateComplete?.();
        },
    });
    let updatedVisualProp: unknown;
    if (answerSessionId && answerSessionId !== '') {
        updatedVisualProp = getUpdatedCustomVisualProp(
            client,
            persistedVisualPropKeys,
            globalPersistedKeyVisualProp,
            answerSessionId,
        );
    }
    const saveAnswer = (
        name: string,
        description: string,
        dynamicName?: string,
        dynamicDescription?: string,
    ) => {
        const clientStateRequests = getClientStateRequest(
            visualizations,
            answerSessionId,
            updatedVisualProp,
        );
        const variables = {
            sessionId: answerSessionId,
            name,
            description,
            ...clientStateRequests,
        };
        if (dynamicName) {
            variables.dynamicName = dynamicName;
        }
        if (!_.isNil(dynamicDescription)) {
            variables.dynamicDescription = dynamicDescription;
        }
        return _saveAnswer({
            variables,
        });
    };
    return {
        saveAnswer,
        data,
        error,
        loading,
    };
};

// Get unsaved Answer TML.
export const useExportUnsavedAnswerMutation = (
    answerSessionId: string,
    showCurrentSearch = false,
) => {
    return useBachMutation<
        GetUnsavedAnswerTmlMutation,
        GetUnsavedAnswerTmlMutationVariables
    >(
        answerSessionId,
        GetUnsavedAnswerTmlDocument,
        {},
        undefined,
        false,
        showCurrentSearch,
    );
};

export const useSaveAnswerMutation = (answerSessionId: string) => {
    const [_saveAnswer, { data, error, loading }] = useBachMutation<
        SaveAnswerMutation,
        SaveAnswerMutationVariables
    >(answerSessionId, SaveAnswerDocument);

    const saveAnswer = (
        name: string,
        description: string,
        chartViz: ChartViz,
    ) => {
        return _saveAnswer({
            variables: {
                sessionId: answerSessionId,
                name,
                description,
            },
        });
    };
    return {
        saveAnswer,
        data,
        error,
        loading,
    };
};

export const useClearAnswerMutation = (answerSessionId: string) => {
    return useBachMutation<ClearAnswerMutation, ClearAnswerMutationVariables>(
        answerSessionId,
        ClearAnswerDocument,
        {
            shouldRefetchData: true,
        },
    );
};

export const useCreateViewMutation = (answerSessionId: string) => {
    // If this request fails, we don't want to show an error message on the viz area, we will
    // instead show an in-context message to the user. Hence, we indicate the error code in the
    // handledErrors field, to tell the base hooks to ignore this error if it occurs.
    const bachAcHistoryContext = useBachAcHistoryContext();
    const [_createView, { data, error, loading }] = useBachMutation<
        CreateViewMutation,
        CreateViewMutationVariables
    >(
        answerSessionId,
        CreateViewDocument,
        isUnsavedChangesModalEnabledForAdhocAnswer()
            ? {
                  onCompleted: () => {
                      bachAcHistoryContext.clearUndoStackAndUpdateResetTarget();
                  },
              }
            : undefined,
        ['10027', '10053', '10054'],
    );

    const createView = async (name: string, description: string) => {
        const response = await _createView({
            variables: {
                name,
                description,
            },
        });
        return { viewId: response?.data?.Answer__saveAsView?.viewId };
    };
    return {
        createView,
        data,
        error,
        loading,
    };
};

export const useUpdateViewMutation = (answerSessionId: string) => {
    const bachAcHistoryContext = useBachAcHistoryContext();

    const [_updateView, { data, error, loading }] = useBachMutation<
        UpdateViewMutation,
        UpdateViewMutationVariables
    >(answerSessionId, UpdateViewDocument, {
        onCompleted: () => {
            bachAcHistoryContext.clearUndoStackAndUpdateResetTarget();
        },
    });

    const updateView = (
        viewId: string,
        updatedViewName: string,
        updatedViewDescription: string,
    ) => {
        return _updateView({
            variables: {
                viewId,
                updatedViewName,
                updatedViewDescription,
            },
        });
    };
    return {
        updateView,
        data,
        error,
        loading,
    };
};

export const getAnswerModel = (sessionId: string, genNo: number) => {
    const fetchUrl = `/prism/getAnswerModel?sessionId=${sessionId}&genNo=${genNo}`;
    return fetch(fetchUrl).then(async res => {
        const jsonResponse = await res.json();
        return jsonResponse;
    });
};

export const getAnswerMetadata = (
    answerSessionId: string,
    client: ApolloClient<object>,
) => {
    const answerMetadata = getCachedAnswer(
        client.cache,
        answerSessionId,
        gql`
            {
                id {
                    sessionId
                }
                answer {
                    id
                    name
                    description
                    displayMode
                    dynamicName
                    dynamicDescription
                    displayName
                    displayDescription
                    sortInfo {
                        columnId
                        sortAscending
                    }
                    metadata {
                        author
                        authorId
                        createdAt
                        modifiedAt
                        generationNum
                        isHidden
                        type
                        isDiscoverable
                    }
                    permission {
                        objectAccessLevel
                        dataSourceAccessLevel
                        dataSourceNamesWithNoAccess
                    }
                    queryableDataSource
                    clientState
                }
            }
        `,
    );

    const answer = answerMetadata?.answer;
    const id = answer?.id;
    const name = answer?.name;
    const description = answer?.description;
    const displayMode = answer?.displayMode;
    const dynamicName = answer?.dynamicName;
    const dynamicDescription = answer?.dynamicDescription;
    const displayName = answer?.displayName;
    const displayDescription = answer?.displayDescription;
    const sortInfo = answer?.sortInfo;
    const isNewAnswer = answer?.metadata.generationNum === '-1';
    const permission = answer?.permission;
    const queryableDataSource = answer?.queryableDataSource;
    const isExternalDataSource =
        queryableDataSource &&
        isExternalDataSourceType(queryableDataSource) &&
        queryableDataSource !== QuerableDataSourceType.FileCsv;
    // todo - should pickup this value from metadata query answer?.metadata.isHidden;
    const isHidden = answer?.metadata.isHidden;
    const authorId = answer?.metadata.authorId;
    const isDiscoverable = answer?.metadata.isDiscoverable;
    const queryState = answer?.clientState?.queryState;

    return {
        id,
        name,
        description,
        dynamicName,
        dynamicDescription,
        displayName,
        displayDescription,
        displayMode,
        isNewAnswer,
        isExternalDataSource,
        sortInfo,
        isHidden,
        permission,
        authorId,
        isDiscoverable,
        queryableDataSource,
        queryState,
    };
};

export const getAnswerVizMetadata = (
    answerSessionId: string,
    client: ApolloClient<object>,
) => {
    const answerMetadata = getCachedAnswer(
        client.cache,
        answerSessionId,
        gql`
            {
                id {
                    sessionId
                }
                answer {
                    id
                    visualizations {
                        id
                        ... on HeadlineViz {
                            id
                            __typename
                        }
                        ... on ChartViz {
                            id
                            __typename
                            config {
                                isLocked
                                chartType
                                customChartManifest {
                                    id
                                    __typename
                                    ... on CustomChartManifest {
                                        iconUrl
                                    }
                                }
                            }
                        }
                        ... on TableViz {
                            id
                            __typename
                        }
                    }
                }
            }
        `,
    );

    // Note: The length of this array will be either 0 or 1
    const charts = answerMetadata?.answer?.visualizations.filter(
        /* eslint-disable-next-line no-underscore-dangle */
        viz => (viz as any).__typename === 'ChartViz',
    );
    const hasChart = Array.isArray(charts) && charts.length > 0;

    // If there is no chart, we show the COLUMN chart as default icon
    // for chart-table-switcher in answer header
    const chartType = hasChart
        ? (charts[0] as ChartViz).config.chartType
        : ChartType.Column;
    let customChartIconUrl;
    if (chartType === ChartType.CustomChart) {
        customChartIconUrl = (charts[0] as ChartViz).config.customChartManifest
            .iconUrl;
    }
    return {
        hasChart,
        chartType,
        customChartIconUrl,
    };
};

export const useGetDisplayVizIdQuery = (
    answerSessionId: string,
    vizId?: string,
) => {
    const { data, error, loading } = useBachQuery<
        GetAnswerMetadataQuery,
        GetAnswerMetadataQueryVariables
    >(answerSessionId, GetAnswerMetadataDocument, { skip: !answerSessionId });

    const displayMode = data?.getAnswer.answer
        .displayMode as keyof typeof displayTypes;

    const displayedVizId = data?.getAnswer?.answer?.visualizations?.find(
        vizId
            ? viz => viz.id === vizId
            : // eslint-disable-next-line no-underscore-dangle
              viz => viz.__typename === displayTypes[displayMode],
    );

    return {
        displayedVizId,
        error,
        loading,
    };
};

export const useGetDisplayVizIdQueryFromAnswer = (
    answerSessionId: string,
    displayMode: DisplayMode,
    vizId?: string,
) => {
    const { answer, loading, error } = useGetAnswerQuery(answerSessionId);

    const displayedVizId = answer?.visualizations?.find(
        vizId
            ? viz => viz.id === vizId
            : viz =>
                  // eslint-disable-next-line no-underscore-dangle
                  viz.__typename ===
                  displayTypes[displayMode as keyof typeof displayTypes],
    );

    return {
        displayedVizId,
        error,
        loading,
    };
};

/**
 * Return an array containing GUIDs of selected sources
 */
export const useGetSelectedSourcesQuery = (
    answerSessionId: string,
    isCacheOnly = false,
) => {
    const { data, error, loading } = useBachQuery<
        GetSelectedSourcesQuery,
        GetSelectedSourcesQueryVariables
    >(
        answerSessionId,
        GetSelectedSourcesDocument,
        isCacheOnly
            ? {
                  fetchPolicy: 'cache-only',
                  skip: !answerSessionId,
              }
            : {
                  skip: !answerSessionId,
              },
    );

    const selectedSources: Array<string> = React.useMemo(
        () =>
            data?.getAnswer?.answer?.sources?.map(
                (source: { header: { guid: string } }) => source.header.guid,
            ),
        [data?.getAnswer?.answer?.sources],
    );

    const nonInputTableSources: Array<string> = React.useMemo(
        () =>
            data?.getAnswer?.answer?.sources
                ?.filter(source => !source.isInputTable)
                .map(
                    (source: { header: { guid: string } }) =>
                        source.header.guid,
                ) ?? [],
        [data?.getAnswer?.answer?.sources],
    );

    return {
        data: selectedSources,
        nonInputTableSources,
        error,
        loading,
    };
};

/**
 * Return an array containing display names of selected sources
 */
export const useGetSelectedSourceNamesQuery = (
    answerSessionId: string,
    skip = false,
) => {
    const { data, error, loading } = useBachQuery<
        GetSelectedSourcesQuery,
        GetSelectedSourcesQueryVariables
    >(answerSessionId, GetSelectedSourcesDocument, { skip });
    const sourceNames: Array<string> = data?.getAnswer.answer.sources
        .filter(source => !source.isInputTable)
        .map(source => source.header.displayName);
    return {
        data: sourceNames,
        error,
        loading,
    };
};

/**
 * Return a set of guids of data sources that are joinable to the current search query.
 * This is indicated by "isAccessible" property of the source.
 */
export const useGetSourcesJoinableToQuery = (
    answerSessionId: string,
    skip = false,
) => {
    const { data, error, loading } = useBachQuery<
        GetSelectedSourcesQuery,
        GetSelectedSourcesQueryVariables
    >(answerSessionId, GetSelectedSourcesDocument, { skip });

    const sourcesJoinableToQuery = React.useMemo(() => {
        const sourceIds = data?.getAnswer.answer.sources
            .filter(source => source.isAccessible)
            .map(source => source.header.guid);
        return new Set(sourceIds);
    }, [data?.getAnswer.answer.sources]);

    return {
        data: sourcesJoinableToQuery,
        error,
        loading,
    };
};

export const getAnswerFromCache = (
    answerSessionId: string,
    client: ApolloClient<object>,
) => {
    const answer = getCachedAnswer(
        client.cache,
        answerSessionId,
        gql`
            {
                id {
                    sessionId
                }
                answer {
                    ...pinboardAnswer
                }
            }
            ${PinboardAnswerFragmentDoc}
        `,
    );
    return answer;
};

/**
 * Embed-specific cache read for the GetAnswerSession path (SCAL-292581).
 * Uses returnPartialData: true and returns the result only for ts-hosted
 * charts (AdvancedPivotTable, MuzeStudio). These are the only chart types
 * that call updateCustomVisualProps — if that mutation hasn't run yet,
 * customVisualProps is absent from cache and a strict read returns null,
 * silently wiping all answer fields from the GetAnswerSession response.
 * For non-ts-hosted charts falls back to the strict getAnswerFromCache.
 */
export const getAnswerFromCachePartial = (
    answerSessionId: string,
    client: ApolloClient<object>,
) => {
    const partialResult = getCachedAnswer(
        client.cache,
        answerSessionId,
        gql`
            {
                id {
                    sessionId
                }
                answer {
                    ...pinboardAnswer
                }
            }
            ${PinboardAnswerFragmentDoc}
        `,
        true,
    );
    const chartViz = partialResult?.answer?.visualizations?.find(
        // eslint-disable-next-line no-underscore-dangle
        (viz: any) => viz.__typename === 'ChartViz',
    );
    if (isCustomOrTsHostedChart((chartViz as any)?.config?.chartType)) {
        return partialResult;
    }
    return getAnswerFromCache(answerSessionId, client);
};

export const getPinboardAnswerWithDataFromCache = (
    answerSessionId: string,
    client: ApolloClient<object>,
) => {
    const answer = getCachedAnswer(
        client.cache,
        answerSessionId,
        gql`
            {
                id {
                    sessionId
                }
                answer {
                    ...pinboardAnswerWithData
                }
            }
            ${PinboardAnswerWithDataFragmentDoc}
        `,
    );
    return answer;
};

export const useMixpanelAnswerCommonProperties = (
    answerSessionId: string,
    client: ApolloClient<object>,
    pageContext: AnswerPageContext,
    isWatchList?: boolean,
) => {
    const mixpanelAnswerData = getAnswerFromCache(answerSessionId, client);
    return getCommonAnswerPageProperties({
        ...mixpanelAnswerData,
        pageContext,
        isWatchList,
    });
};

export const getAnswerHeaderMetadataFromCache = (
    answerSessionId: string,
    client: ApolloClient<object>,
) => {
    const cachedAnswer = getAnswerFromCache(answerSessionId, client);
    const answer = cachedAnswer?.answer;
    const id = answer?.id;
    const name = answer?.name;
    const description = answer?.description;
    const isNewAnswer = answer?.metadata.generationNum === '-1';
    const isHidden = answer?.metadata.isHidden;
    const displayMode = answer?.displayMode;

    return {
        id,
        name,
        description,
        isNewAnswer,
        isHidden,
        displayMode,
    };
};

/**
 * Return a set containing GUIDs of selected columns
 */
export const useGetSelectedColumnsQuery = (answerSessionId: string) => {
    const { data, error, loading } = useBachQuery<
        GetSelectedColumnsQuery,
        GetSelectedColumnsQueryVariables
    >(answerSessionId, GetSelectedColumnsDocument);

    return {
        data: getSelectedColumnsFromQueryData(data),
        error,
        loading,
    };
};

/**
 * Fetch the list of columns that are included in the sage query. Since the user could have edited
 * the sage query after the last bach request, it is possible the sage query state is out of sync
 * with the latest bach state. Therefore, we must send the AC session info in the request, to get
 * the selected columns for the latest sage query state.
 */
export const useGetSelectedColumnsLazyQuery = (
    answerSessionId: string,
    useNetworkOnlyFetchPolicy = false,
) => {
    const [
        getSelectedColumns,
        { data, error, loading, refetch },
    ] = useBachLazyQuery<
        GetSelectedColumnsQuery,
        GetSelectedColumnsQueryVariables
    >(
        answerSessionId,
        GetSelectedColumnsDocument,
        {
            variables: {
                isClientStateUpgradeRequired: false,
                session: undefined,
            },
            ...(useNetworkOnlyFetchPolicy
                ? { fetchPolicy: 'network-only' }
                : {}),
        },
        // See top level comment for why we need this
        true,
    );

    const [latestData, setLatestData] = React.useState<Set<string>>(new Set());
    React.useEffect(() => {
        if (!data) {
            return;
        }

        // Check if the "new" data is actually the same set of columns as the previous data
        const newData = getSelectedColumnsFromQueryData(data);
        if (
            latestData.size === newData.size &&
            Array.from(latestData).every(val => newData.has(val))
        ) {
            return;
        }

        setLatestData(newData);
    }, [data]);

    // Memoize return object to prevent causing re-renders in consuming components
    return React.useMemo(
        () => ({
            getSelectedColumns,
            refetch,
            data: latestData,
            error,
            loading,
        }),
        [getSelectedColumns, refetch, latestData, error, loading],
    );
};

/**
 * Return getSelectedColumns and a set containing GUIDs of selected columns using lazy query
 */
export const useGetSelectedOutputColumnsQuery = (answerSessionId: string) => {
    const { data, error, loading } = useBachQuery<
        GetSelectedOutputColumnsQuery,
        GetSelectedOutputColumnsQueryVariables
    >(answerSessionId, GetSelectedOutputColumnsDocument, {
        fetchPolicy: 'no-cache',
    });

    const [
        latestSelectedOutputColumns,
        setLatestSelectedOutputColumns,
    ] = React.useState([]);
    React.useEffect(() => {
        if (!data) {
            return;
        }
        setLatestSelectedOutputColumns(
            data.getAnswer.answer.selectedColumns.concat(
                data.getAnswer.answer.selectedFormulas as SelectedColumn,
            ),
        );
    }, [data]);

    return {
        data: latestSelectedOutputColumns,
        error,
        loading,
    };
};

export const useGetAnswerColumnsAndDataQuery = (
    answerSessionId: string,
    displayMode: DisplayMode,
    dataQueryInput?: DataQueryInput,
) => {
    const client = useApolloClient();

    let Document: DocumentNode;
    let typename: string;
    if (displayMode === DisplayMode.ChartMode) {
        Document = GetAnswerChartColumnsAndDataDocument;
        typename = 'ChartViz';
    } else {
        Document = GetAnswerTableColumnsAndDataDocument;
        typename = 'TableViz';
    }

    const { data } = useBachQuery<any, any>(answerSessionId, Document, {
        fetchPolicy: 'cache-only',
    });
    let queriedVisualizations = data?.getAnswer?.answer?.visualizations;
    if (
        queriedVisualizations?.length === 0 &&
        fetchVizRefsForAnswerSession(client.cache, answerSessionId).length !== 0
    ) {
        const chartVizCache = readFromLBChartVizCache(answerSessionId)
            ?.chartViz;
        if (chartVizCache) {
            queriedVisualizations = [chartVizCache];
        }
    }

    const visualization = queriedVisualizations?.find(
        // eslint-disable-next-line no-underscore-dangle
        (viz: ChartViz | TableViz) => viz.__typename === typename,
    );

    // Get chartType from visualization if it's a ChartViz
    const chartType =
        // eslint-disable-next-line no-underscore-dangle
        visualization?.__typename === 'ChartViz'
            ? (visualization as ChartViz).config?.chartType
            : undefined;

    // For custom or tsHosted charts, set data on visualization
    // Need to create a copy since Apollo cache objects are frozen/read-only
    let resultVisualization = visualization;

    if (
        visualization &&
        chartType &&
        isCustomOrTsHostedChart(chartType) &&
        dataQueryInput &&
        visualization.id
    ) {
        // For custom or tsHosted charts, read cached data using getAnswerDataByQuery
        // Use direct cache read approach for better performance
        const combineQueries: boolean = shouldCombineMultipleQueriesForCustomChart();
        const session = getSession(
            client,
            answerSessionId,
            'BachSessionId',
            bachSessionWithAcSessionKeyQuery,
            ['acSession'],
        );
        const cacheVariables = {
            session: {
                acSession: session.acSession,
            },
            dataQueries: dataQueryInput,
            vizId: visualization?.id,
            combineQueries,
        } as GetAnswerDataByQueryQueryVariables;

        const answerDataByQueryData = client.cache.readQuery({
            query: GetAnswerDataByQueryDocument,
            variables: cacheVariables,
        }) as GetAnswerDataByQueryQuery;
        if (
            answerDataByQueryData?.getAnswerDataByQuery?.data &&
            displayMode === DisplayMode.ChartMode &&
            isCustomOrTsHostedChart(chartType)
        ) {
            // Parse and set the data on the visualization using the shared parsing function
            const parsedData: any = getParsedQueryResponseForAnswerDataByQueryCall(
                answerDataByQueryData,
            );
            // Create a shallow copy of visualization to avoid mutating frozen Apollo cache object
            resultVisualization = {
                ...visualization,
                data: parsedData,
            } as ChartViz;
        }
    }

    return resultVisualization;
};

/**
 * Return a map of data sources that are referenced in the answer.
 * Maps from GUID to displayName.
 */
export const getReferencedDataSourcesFromCache = (
    answerSessionId: string,
    client: ApolloClient<object>,
) => {
    const cachedAnswer = getAnswerFromCache(answerSessionId, client);

    const tableViz = cachedAnswer?.answer.visualizations.find(
        viz =>
            /* eslint-disable-next-line no-underscore-dangle */
            (viz as any).__typename === 'TableViz',
    );

    const chartViz = cachedAnswer?.answer.visualizations.find(
        viz =>
            /* eslint-disable-next-line no-underscore-dangle */
            (viz as any).__typename === 'ChartViz',
    );

    // Maps from GUID to displayName of data sources that are referenced in the answer
    const referencedDataSources: Map<string, string> = new Map();

    if (tableViz) {
        const referencedTables = (tableViz as TableViz).columns
            .filter(({ column }) => column.referencedTables?.length > 0)
            .map(({ column }) => column.referencedTables[0]);

        referencedTables.forEach(({ guid, displayName }) => {
            if (guid) {
                referencedDataSources.set(guid, displayName);
            }
        });
    } else if (chartViz) {
        // If TableViz data is not available, that would be in case of pinboard viz,
        // get datasources from ChartViz
        const referencedTables = (chartViz as ChartViz).columns
            .filter(({ column }) => column.referencedTables?.length > 0)
            .map(({ column }) => column.referencedTables[0]);

        referencedTables.forEach(({ guid, displayName }) => {
            if (guid) {
                referencedDataSources.set(guid, displayName);
            }
        });
    }

    return {
        data: referencedDataSources,
    };
};

export const getCachedQueryableDataSource = (
    client: ApolloClient<object>,
    answerSessionId: string,
): QuerableDataSourceType => {
    const cachedAnswerSession = getCachedAnswer(
        client.cache,
        answerSessionId,
        gql`
            {
                answer {
                    id
                    name
                    queryableDataSource
                }
            }
        `,
    );
    return cachedAnswerSession?.answer?.queryableDataSource;
};

export function useAnswerHasUnsavedChanges() {
    const answerHistorContext = useBachAcHistoryContext();
    const client = useApolloClient();
    const { answerSessionId } = getAnswerPageConfig();
    const cachedAnswer = getCachedAnswerForHasUnsavedChanges(
        client.cache,
        answerSessionId,
    );
    // In case of an empty answer, the answer cannot be saved
    // Hence, we return there are no unsaved changes.
    if (
        (isUnsavedChangesModalEnabledForAdhocAnswer() &&
            !cachedAnswer.answer?.hashKey) ||
        (!isUnsavedChangesModalEnabledForAdhocAnswer() &&
            (!cachedAnswer.answer?.hashKey || !cachedAnswer.refAnswer))
    ) {
        return { hasUnsavedChanges: false };
    }

    return {
        hasUnsavedChanges: answerHistorContext?.canReset,
    };
}

export function useNLQMutation(answerSessionId: string) {
    return useBachMutation<
        GetNaturalLanguageQueryMutation,
        GetNaturalLanguageQueryMutationVariables
    >(answerSessionId, GetNaturalLanguageQueryDocument);
}

export const useQueryMutation = (answerSessionId: string) => {
    return useBachMutation<GetQueryMutation, GetQueryMutationVariables>(
        answerSessionId,
        GetQueryDocument,
    );
};

export const useGetQVSpecMutation = (answerSessionId: string) => {
    return useBachMutation<GetQvSpecMutation, GetQvSpecMutationVariables>(
        answerSessionId,
        GetQvSpecDocument,
    );
};

export function useGetA3AnalysisColumns(answerSessionId: string) {
    // Gated so the mutation is deferred until the answer session is fully
    // hydrated, preventing it from firing against a stale pre-hydration session.
    // Menu Item: SpotIQ
    return useGatedBachMutation<
        GetA3AnalysisColumnsMutation,
        GetA3AnalysisColumnsMutationVariables
    >(answerSessionId, GetA3AnalysisColumnsDocument);
}

export function useA3AnalysisSubmission(answerSessionId: string) {
    return useBachMutation<
        A3AnalysisSubmissionMutation,
        A3AnalysisSubmissionMutationVariables
    >(answerSessionId, A3AnalysisSubmissionDocument);
}

export function useA3AnalysisSync(
    answerSessionId: string,
    signal?: AbortSignal,
) {
    const context =
        signal && !signal.aborted
            ? {
                  fetchOptions: {
                      signal,
                  },
              }
            : {};

    return useBachMutation<
        A3AnalysisSyncMutation,
        A3AnalysisSyncMutationVariables
    >(answerSessionId, A3AnalysisSyncDocument, { context });
}

export const useDeleteAnswerMutation = (answerSessionId: string) => {
    const [deleteAnswer, { data, loading, error }] = useBachMutation<
        DeleteAnswerMutation,
        DeleteAnswerMutationVariables
    >(answerSessionId, DeleteAnswerDocument, {
        setVisualizationsLoading: true,
    });
    const client = useApolloClient();

    return {
        deleteAnswer: (id: string) => {
            const response = deleteAnswer({
                variables: {
                    id,
                },
            });
            //  removed ref because  we use cache answer in many places, and if on re-rendering we
            //  don't have the answer present in cache, it will throw error "cannot read property of undefined".
            if (response)
                evictRefAnswerOfAnswerEditSession(client, answerSessionId);
            return response;
        },
        useDeleteAnswerMutation,
        data,
        loading,
        error,
    };
};

export const useReportIssueMutation = () => {
    const [reportIssueMutation, { loading, error }] = useMutation<
        ReportIssueMutation,
        ReportIssueMutationVariables
    >(ReportIssueDocument, {
        // Handle all errors locally to prevent them from propagating to the
        // ErrorContext and causing the answer visualization to show an error page.
        // The caller (onReportIssue in answer-actions.container.tsx) handles
        // errors with its own try-catch and shows a banner alert.
        handledErrors: ['*'],
    });

    const reportIssue = async (variables: ReportIssueMutationVariables) => {
        const result = await reportIssueMutation({ variables });
        return result.data?.Answer__reportIssue;
    };

    return { reportIssue, loading, error };
};

export function useSetTMLString(
    answerSessionId: string,
    onCompleted?: (data: SetTmlStringMutation) => void,
    onError?: (error: ApolloError) => void,
) {
    const client = useApolloClient();

    const [_setTMLString, { data, error, loading }] = useBachMutation<
        SetTmlStringMutation,
        SetTmlStringMutationVariables
    >(answerSessionId, SetTmlStringDocument, {
        // Always true: SetTMLString changes the underlying query regardless of
        // updateOnlyPhrases, so viz data must be re-fetched to stay in sync.
        // Drives the same unmount/remount cycle as AddColumns, SetTokens, etc.
        shouldRefetchData: true,
        onCompleted,
        onError,
    });
    const focusAfterUpdate = React.useRef(false);
    const setTMLString = async ({
        variables,
        shouldFocusAfterUpdate,
    }: {
        variables: Omit<SetTmlStringMutationVariables, 'session'>;
        shouldFocusAfterUpdate?: boolean;
    }) => {
        focusAfterUpdate.current = shouldFocusAfterUpdate;

        if (variables.updateOnlyPhrases) {
            return _setTMLString({ variables });
        }

        setVisualizationLoading(
            client,
            answerSessionId,
            LoadingState.InProgress,
        );

        try {
            const result = await _setTMLString({ variables });

            setVisualizationLoading(
                client,
                answerSessionId,
                result?.errors?.length
                    ? LoadingState.Failure
                    : LoadingState.Success,
            );

            return result;
        } catch (error) {
            setVisualizationLoading(
                client,
                answerSessionId,
                LoadingState.Failure,
            );

            throw error;
        }
    };
    return {
        setTMLString,
        focusAfterUpdate,
        TMLStringData: data,
        TMLStringDataLoading: loading,
        error,
    };
}

export function useSubmitRAnalysisMutation(answerSessionId: string) {
    const [submitRAnalysis, { data, loading }] = useBachMutation<
        SubmitRAnalysisMutation,
        SubmitRAnalysisMutationVariables
    >(answerSessionId, SubmitRAnalysisDocument);
    return {
        submitRAnalysis: (customRScript: CustomRAnalysis) =>
            submitRAnalysis({
                variables: {
                    customRScript,
                },
            }),
        data,
        loading,
    };
}

export function useAbortControlller() {
    const flightRequestAbortController = React.useRef<AbortController>(
        new window.AbortController(),
    );
    return flightRequestAbortController;
}

export function getVizFromAnswer(answer: Partial<Answer>) {
    const displayMode: DisplayMode = answer.displayMode;
    const displayModeToVizTypeMap: Partial<Record<DisplayMode, string>> = {
        [DisplayMode.ChartMode]: 'ChartViz',
        [DisplayMode.TableMode]: 'TableViz',
        [DisplayMode.HeadlineMode]: 'HeadlineViz',
        [DisplayMode.RAnalysisMode]: 'RAnalysisViz',
    };
    const vizType = displayModeToVizTypeMap[displayMode];
    if (!vizType) return null;
    let vizFromAnswer = _.find(
        answer.visualizations,
        // eslint-disable-next-line no-underscore-dangle
        (viz: FinalVisualization) => viz.__typename === vizType,
    );
    // check for possible Headline Visualization
    if (displayMode === DisplayMode.TableMode && !vizFromAnswer) {
        vizFromAnswer = _.find(
            answer.visualizations,
            // eslint-disable-next-line no-underscore-dangle
            (viz: FinalVisualization) => viz.__typename === 'HeadlineViz',
        );
    }
    return vizFromAnswer;
}

export const useGetAnswerOrderedChips = (answerSessionId: string) => {
    const { data, error, loading } = useBachQuery<
        GetAnswerOrderedChipsQuery,
        GetAnswerOrderedChipsQueryVariables
    >(answerSessionId, GetAnswerOrderedChipsDocument, {
        skip: !answerSessionId,
    });
    return {
        orderedChips: !_.isEmpty(data?.getAnswer.answer.orderedChips)
            ? data?.getAnswer.answer.orderedChips
            : null,
        error,
        loading,
    };
};

export const useAnswerReorderChipsMutation = (answerSessionId: string) => {
    const [_onReorderChips, { data, loading, error }] = useBachMutation<
        UpdateAnswerChipsOrderMutation,
        UpdateAnswerChipsOrderMutationVariables
    >(answerSessionId, UpdateAnswerChipsOrderDocument);

    const onReorderChips = (updatedOrderedChips: ChipInput[]) => {
        return _onReorderChips({
            variables: {
                updatedOrderedChips,
            },
        });
    };

    return {
        onReorderChips,
        data,
        loading,
        error,
    };
};

/*
 * Return the list of columns which are in the search query of the current visualization,
 * regardless of the type of visualization. This includes both visualized and unvisualized columns.
 */
export const useGetAllColumnsQuery = (answerSessionId: string) => {
    const client = useApolloClient();
    const { data, error, loading } = useBachQuery<
        GetVisualizedColumnsQuery,
        GetVisualizedColumnsQueryVariables
    >(answerSessionId, GetVisualizedColumnsDocument);

    const allColumns = React.useMemo(() => {
        if (!data) return [];
        const answer = data?.getAnswer.answer;
        let viz = getVizFromAnswer(answer);

        // In case of liveboard load, we evict the chart viz cache from apollo cache
        // and store in local cache to avoid memory bloat by apollo watchers
        // Any component that needs chart viz will read from local cache
        if (
            answer?.displayMode === DisplayMode.ChartMode &&
            !viz &&
            fetchVizRefsForAnswerSession(client.cache, answerSessionId).length
        ) {
            viz = readFromLBChartVizCache(answerSessionId)?.chartViz;
        }
        return getColumnsFromViz(viz, false);
    }, [data]);

    return {
        allColumns,
        error,
        loading,
    };
};

/*
 * Return the list of columns which are visualized in the current visualization, regardless of the
 * type of visualization
 */
export const useGetVisualizedColumnsQuery = (answerSessionId: string) => {
    const client = useApolloClient();
    const { data, error, loading } = useBachQuery<
        GetVisualizedColumnsQuery,
        GetVisualizedColumnsQueryVariables
    >(answerSessionId, GetVisualizedColumnsDocument);

    const visualizedColumns = React.useMemo(() => {
        if (!data) return [];

        const answer = data?.getAnswer.answer;
        let viz = getVizFromAnswer(answer);

        // In case of liveboard load, we evict the chart viz cache from apollo cache
        // and store in local cache to avoid memory bloat by apollo watchers
        // Any component that needs chart viz will read from local cache
        if (
            answer?.displayMode === DisplayMode.ChartMode &&
            !viz &&
            fetchVizRefsForAnswerSession(client.cache, answerSessionId).length
        ) {
            viz = readFromLBChartVizCache(answerSessionId)?.chartViz;
        }
        return getColumnsFromViz(viz);
    }, [data]);

    return {
        visualizedColumns,
        error,
        loading,
    };
};

export function useCCAColumnConfig(answerSessionId: string) {
    return useBachMutation<
        SetCcaColumnConfigMutation,
        SetCcaColumnConfigMutationVariables
    >(answerSessionId, SetCcaColumnConfigDocument);
}

export const useGetAnswerMetadata = (answerSessionId: string) => {
    const { data, error, loading } = useBachQuery<
        GetAnswerMetadataQuery,
        GetAnswerMetadataQueryVariables
    >(answerSessionId, GetAnswerMetadataDocument, { skip: !answerSessionId });

    return data?.getAnswer.answer;
};

export function useGetBrokenAnswerTokenDetails(answerSessionId: string) {
    const { data, error, loading } = useBachQuery<
        GetBrokenAnswerDetailsQuery,
        GetBrokenAnswerDetailsQueryVariables
    >(answerSessionId, GetBrokenAnswerDetailsDocument);

    const brokenAnswerTokenDetails = React.useMemo(() => {
        return data?.getAnswer?.answer?.incompeleteAnswerDetails
            ?.brokenTokenDetails;
    }, [data?.getAnswer?.answer?.incompeleteAnswerDetails?.brokenTokenDetails]);

    return {
        brokenAnswerTokenDetails,
        loading,
        error,
    };
}

export const useUpdateLastSelectedSourcesMutation = () => {
    const [
        updateLastSelectedDataSources,
        { data, error, loading },
    ] = useMutation<
        UpdateLastSelectedDataSourcesMutation,
        UpdateLastSelectedDataSourcesMutationVariables
    >(UpdateLastSelectedDataSourcesDocument);

    return {
        data,
        error,
        loading,
        updateLastSelectedDataSources: (ids: string[]) =>
            updateLastSelectedDataSources({
                variables: {
                    ids,
                },
            }),
    };
};
